import * as React from "react";
import * as ReactDOM from "react-dom";
import { observable } from "mobx";
import { observer, MobXProviderContext, Provider } from "mobx-react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Box, Button, Grid, ThemeProvider, useMediaQuery } from "@material-ui/core";
import { MUIBlock, SnackbarNotifier, Theme as theme } from "../panel/MUI";
import { SiteHeader } from "../panel/header";
import { SiteFooter } from "../panel/footer";
import * as styles from "./styles.scss";


import FSNotifierStore from "../../components/Notifier/store";

import { RegisterForm } from "./Register";
import { SignInForm } from "./SignIn";
import { RestoreForm } from "./Restore";
import { AuthedForm } from "./Authed";
import { CourseInfo } from "./CourseCard";
import { PageInfo } from "./PageInfo";
import {
  IAPIData,
  IAuthedInfo,
  ICourseInfo,
  IDoubleauthData,
  IRegistrationConfig,
  ISocialsData,
} from "./types";
import { PhoneConfirm } from "./PhoneConfirm";

import { LoginPageContext } from "./context";
import {tl} from "../../utils";


import "../panel/WelcomePage/index"
interface IProps {
  socials: ISocialsData | null;
  showHeader: boolean;
  page: {
    logo: string | null;
    title: string;
    footer: string | null;
    info: string | null;
  };
  course_info: ICourseInfo | null;
  authed_info: IAuthedInfo | null;
  doubleauth_data: IDoubleauthData | null;
  forms: {
    login: IAPIData;
    restore: IAPIData;
    register: IRegistrationConfig;
  };
  host: string;
  isCustom: boolean;
}

class Stores {
  @observable fsNotifierStore: FSNotifierStore;
  constructor() {
    this.fsNotifierStore = new FSNotifierStore(this);
  }
}
const stores = new Stores();

export const LoginPage = observer((props: IProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"), {
    //баг г*вна в муях
    noSsr: true
  });
  const { fsNotifierStore } = React.useContext<{
    fsNotifierStore: FSNotifierStore;
  }>(MobXProviderContext);
  const [authedInfo, setAuthedInfo] = React.useState<IAuthedInfo>(
    props.authed_info
  );
  const [doubleauthData, setDoubleauthData] = React.useState<IDoubleauthData>(
    props.doubleauth_data
  );
  const [mobileStep, setMobileStep] = React.useState<number>(0);

  React.useEffect(() => {
    document.title = props.page.title || "";
  }, [props.page.title]);

  const handleMobileStep = React.useCallback((value: number) => {
    setMobileStep(value)
  }, [])

  return (
    <LoginPageContext.Provider
      value={{
        addNotice: fsNotifierStore.addNotice,
        mobileStep,
        setMobileStep: handleMobileStep,
        isCustom: props.isCustom,
      }}
    >
      <Box flex={1} overflow="hidden" clone>
        <Grid container direction="column" justifyContent="space-between">

          {props.showHeader ? (
            <Grid item data-testid="header">
              <SiteHeader logo={props.page.logo} isCustom={props.isCustom} />
            </Grid>
          ) : null}
          <Grid item className={styles.miniWindowWrap}>
            <MUIBlock className={styles.miniWindow}>
              {props.course_info ? (
                <CourseInfo 
                  description={props.course_info.description} 
                  title={props.course_info.title} 
                  icon={props.course_info.icon} 
                />
              ) : props.page.info ? (
                <PageInfo {...props.page} />
              ) : null}
              <Switch>
                <Route path="/login/restore">
                  <RestoreForm apiData={props.forms.restore} />
                </Route>
                <Route path="/login/doubleauth">
                  <PhoneConfirm
                    apiData={props.forms.login}
                    host={props.host}
                    doubleauthData={doubleauthData}
                    isCourse={!!props.course_info}
                  />
                </Route>
                <Route path={["/login", "/"]} exact>
                  {authedInfo ? (
                    <AuthedForm
                      authData={authedInfo}
                      setAuthData={setAuthedInfo}
                    />
                  ) : (
                    <SignInForm
                      onDoubleauth={setDoubleauthData}
                      host={props.host}
                      apiData={props.forms.login}
                      socialsData={props.socials}
                      showFieldsOnMobile
                    />
                  )}
                </Route>
                <Route
                  path="/:registerCode"
                  render={(rrdProps) =>
                    authedInfo ? (
                      <AuthedForm
                        authData={authedInfo}
                        setAuthData={setAuthedInfo}
                      />
                    ) : (
                      <Grid
                          container
                          spacing={6}
                          className={styles.registerPage}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          className={mobileStep >= 5 ? styles.xsHidden : ""}
                        >
                          <RegisterForm
                              {...rrdProps}
                              registrationConfig={props.forms.register}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          className={mobileStep === 1 ? styles.xsHidden : ""}
                        >
                          {(!isMobile || (isMobile && mobileStep === 5)) &&
                            <SignInForm
                              onDoubleauth={setDoubleauthData}
                              host={props.host}
                              apiData={props.forms.login}
                              socialsData={props.socials}
                            /> 
                          }
                        </Grid>
                      </Grid>
                    )
                  }
                />
              </Switch>
            </MUIBlock>
          </Grid>
          {props.page.footer ? (
            <Grid item>
              <SiteFooter link={props.page.footer} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <SnackbarNotifier />
    </LoginPageContext.Provider>
  );
});

const renderEmbedLogin = (data: IProps) => {
  return (
    <BrowserRouter>
      <Provider {...stores}>
        <ThemeProvider theme={theme}>
          <LoginPage {...data} />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  );
};

export default renderEmbedLogin;